/* eslint-disable max-len */
const { Background } = require('@andes-landings/background');
const React = require('react');
const { Image } = require('@andes/common');
const { CarouselSnapped } = require('@andes/carousel-snapped');
const SearchBar = require('../../../SearchBar');
const AllCards = require('./cards');
const { CarouselSnappedSlide } = CarouselSnapped;
const { OnlinePayments, InPersonPayments, AllSolutions } = require('./cardsImages');

const HeaderDocs = ({ lang, isMobile, siteId, i18n, assetsPath, brand }) => {
  const CardsAll = [
    { icon: <OnlinePayments />, title: i18n.jsx.gettext('Guía para {0} cobro online', { tags: { 0: '<br />' } }), href: '#online-payments', track: 'online-payment', sitesUnavailable: [], label: i18n.gettext('Ir a Guía para cobro online') },
    { icon: <InPersonPayments />, title: i18n.jsx.gettext('Guía para{0}cobro presencial', { tags: { 0: '<br />' } }), href: '#inperson-payments', track: 'inperson-payment', sitesUnavailable: ['MCO', 'MPE'], label: i18n.gettext('Ir a Guía para cobro presencial') },
    { icon: <AllSolutions />, title: i18n.gettext('Todas nuestras soluciones'), href: '#all-docs', track: 'gallery-products', sitesUnavailable: [], label: i18n.gettext('Ir a Todas nuestras soluciones') },
  ];

  const imageLang = lang === 'pt' ? 'pt' : 'es';

  const Cards = CardsAll.filter((m) => !m.sitesUnavailable.includes(siteId));

  const TitleHeader = isMobile ? i18n.gettext('Explora cómo integrar nuestras soluciones de cobro')
    : i18n.jsx.gettext('Explora cómo integrar las {0} soluciones de cobro de Mercado Pago', { tags: { 0: '<br />' } });

  return (
    <Background
      component="section"
      className="header"
      curves={3}
      type="hero"
      style={isMobile ? { Padding: 62.50 } : { padding: 0 }}
      inverted={brand === 'yellowblue-light'}
      >
      <div className="header-content">
        <div className="header-content-top">

          <div className="header-content-title">
            <div className="header-title">
              <h3 className="header-title-volanta" data-brand={brand}>{i18n.gettext('DOCUMENTACIÓN')}</h3>
              <h1 className="header-title-description" data-brand={brand}>{TitleHeader}</h1>
            </div>

            <div className="header-content-search">
              <SearchBar
                lang={lang}
                isMobile={isMobile}
                siteId={siteId}
                maxBoxVH={50}
              />
            </div>
          </div>

          <div className="header-content-image">
            <Image
              className="docs-hero-image"
              src={`${assetsPath}images/docs-hero-${imageLang}-${brand}.png`}
            />
          </div>

        </div>

        {isMobile ? (
          <CarouselSnapped
            arrows={false}
            scroll="hidden"
            slidesPerView={2.8}
            className="header-container-cards"
            spacing={0}
          >
            {Cards.map((card) => (
              <CarouselSnappedSlide className="header-container-cards-snapped">
                <AllCards card={card} lang={lang} />
              </CarouselSnappedSlide>
            ))}
          </CarouselSnapped>
        ) : (
          <div className="header-container-cards">
            { Cards.map((card) => (<AllCards card={card} lang={lang} />))}
          </div>
        )}
      </div>
    </Background>
  );
};

module.exports = HeaderDocs;
